<template>
  <v-container v-if="name && releases">
    <page-header :title="decodeURIComponent(releases.label)" :info="lang.labelReleases(releases.label)" />
    <v-card>
      <v-card-text>
        <v-list three-line>
          <template v-for="(release, index) in releases.releases">
            <v-list-tile ripple :key="index" :title="lang.viewMoreInfo(release.title)" :to="`/albums/${release.id}`">
              <v-list-tile-avatar v-if="release.cover" :size="64" :class="['mt-1', 'mr-4']">
                <img :src="release.cover" :alt="release.cover" />
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title v-html="release.band || release.title" />
                <v-list-tile-sub-title v-html="release.title || release.band" />
              </v-list-tile-content>
              <chevron-right />
            </v-list-tile>
            <v-divider :key="index + '-divider'" v-if="index < releases.releases.length - 1" />
          </template>
        </v-list>
      </v-card-text>
    </v-card>
    <div hidden v-html="lang.labelReleases(releases.label)" :class="['meta-description']" />
  </v-container>
</template>
<script>
import lang from '../helpers/lang'
import methods from '../helpers/methods'

export default {
  name: 'labels-name',
  mixins: [
    methods
  ],
  data () {
    return {
      lang,
      name: null,
      releases: null
    }
  },
  watch: {
    /**
     * route.params.name watcher
     */
    '$route.params.name' () {
      this.onMounted()
    }
  },
  mounted () {
    this.onMounted()
  },
  methods: {
    /**
     * Mounted event handler
     * @method onMounted
     * @return {void}
     */
    onMounted () {
      this.name = this.$route.params.name
      const cache = this.getCachedPage('labels', this.name)
      cache ? this.done(cache) : this.getLabelData()
    },
    /**
     * Get the label data from the API
     * @method getLabelData
     * @return {void}
     */
    getLabelData () {
      const url = this.$root.routes.find(route => route.url.includes('labels/:')).url.replace(':name', encodeURIComponent(this.name))
      this.$http(url)
        .then(response => {
          this.done(response.data.payload)
        })
    },
    done (response = null) {
      this.releases = response
      this.$nextTick(() => {
        this.emitRouteChange()
        this.$nextTick(() => {
          this.setLastBreadcrumbsItemText(this.releases.label)
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/labels-name.vue